function _escape(v: unknown): string {
  const s = String(v ?? "");
  return s.includes(",") || s.includes('"') || s.includes("\n")
    ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(rows: Record<string, unknown>[]): string {
  if (!rows?.length) return "";
  const cols = Object.keys(rows[0]);
  const lines = [
    cols.map(_escape).join(","),
    ...rows.map((r) => cols.map((c) => _escape(r[c])).join(",")),
  ];
  return lines.join("\n");
}

function _triggerDownload(content: string, filename: string, type: string): void {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadCsv(rows: Record<string, unknown>[], filename = "report"): void {
  _triggerDownload(toCsv(rows), `${filename}.csv`, "text/csv");
}

export function downloadJson(rows: unknown, filename = "report"): void {
  _triggerDownload(JSON.stringify(rows, null, 2), `${filename}.json`, "application/json");
}
